/* eslint-disable jsx-a11y/control-has-associated-label */
import React from 'react';
import PropTypes from 'prop-types';

import '../CallForSpeakers.scss';

export const AddSpeakerButton = ({ addSpeaker }) => (
  <div className="form-group columns is-vcentered">
    <button
      className="button is-medium is-rounded btn-submit"
      id="add-speaker-button"
      onClick={addSpeaker}
      type="submit">
      Add Speaker for Talk
    </button>
    <p className="help">You can nominate up to 5 speakers per one talk.</p>
  </div>
);

export const RemoveButton = ({ id, removeSpeaker }) => (
  <div className="form-group columns">
    <div className="column is-1 is-offset-11">
      <button
        className="delete is-large remove-button"
        onClick={() => removeSpeaker(id)}
        type="button"
      />
    </div>
  </div>
);

AddSpeakerButton.propTypes = {
  addSpeaker: PropTypes.func.isRequired
};

RemoveButton.propTypes = {
  id: PropTypes.number.isRequired,
  removeSpeaker: PropTypes.func.isRequired
};
